/**
 * Status type
 */
export const StatusType = type => {
  switch (type) {
    case 'info':
      return 'info';
    case 'warning':
      return 'warning';
    case 'error':
      return 'danger';
    default:
      return type;
  }
};
